var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{class:_vm.color},[_vm._v("עם ")]),_c('router-link',{class:_vm.color,attrs:{"to":{name: 'teacherPage', params:{tid: _vm.teacherId}}}},[_vm._v("\n"+_vm._s(_vm.teacher.name))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }